// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	const style = document.createElement('style');
	const body = document.querySelector("body");
	const scrollbarWidth = window.innerWidth - body.clientWidth;
	const headerHeight = document.querySelector("#header").offsetHeight;
	//body.setAttribute("style", `--scrollbar-width: ${scrollbarWidth}px;--header-height: ${headerHeight}px`);
	document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	// Parallax
	window.addEventListener('scroll', function(event) {
		var depth, i, layer, layers, len, movement, topDistance, translate3d;
		topDistance = this.pageYOffset;
		layers = document.querySelectorAll("[data-type='parallax']");
		for (i = 0, len = layers.length; i < len; i++) {
			layer = layers[i];
			depth = layer.getAttribute('data-depth');
			movement = -(topDistance * depth);
			translate3d = 'translate3d(-50%, ' + movement + 'px, 0)';
			layer.style['-webkit-transform'] = translate3d;
			layer.style['-moz-transform'] = translate3d;
			layer.style['-ms-transform'] = translate3d;
			layer.style['-o-transform'] = translate3d;
			layer.style.transform = translate3d;
		}
	});
			

})();